//api-consts.ts
// const DEFAULT_BASE_API_URL = 'http://ai.cesi.rt:49152/';
// export const BASE_API_URL = (process.env.REACT_APP_BASE_API_URL as string) || DEFAULT_BASE_API_URL;
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || 'https://stratai.ailang.ru/';
console.log("API URL: ", process.env.REACT_APP_BASE_API_URL);
export const OBTAIN_TOKEN_URL = `${BASE_API_URL}auth/login`;
export const REFRESH_TOKEN_URL = `${BASE_API_URL}auth/refresh`;
export const VERIFY_TOKEN_URL = `${BASE_API_URL}auth/verify`;

// Новые эндпоинты для документов и связанных сущностей
// Note: BASE_API_URL already includes /api/, so these are relative paths
export const DOCUMENTS_ENDPOINT = `documents/`;
export const DOCUMENT_TYPES_ENDPOINT = `documenttypes/`;
export const PROPERTIES_ENDPOINT = `properties/`;
export const PROPERTY_TYPES_ENDPOINT = `propertytypes/`;
export const OPERATIONS_ENDPOINT = `operations/`;
export const DOCUMENTS_UPLOAD_ENDPOINT = `documents/upload`;
